import { Document } from './document.js'

export * from './document.js'

export default Document
